<div class="popup-container d-flex flex-column">
  <label class="heading-text">
    Are you sure you want to add {{ mergedFcCount }} Family Codes?
  </label>
  <label class="content"
    >This is a critical action, please be sure before proceeding!</label
  >
  <form>
    <div class="comment-div d-flex justify-content-between flex-column">
      <div class="heading-div d-flex justify-content-between">
        <span class="comments">Add comments (Optional)</span>
        <span class="comments">{{ count }}/120</span>
      </div>
      <textarea
        type="textarea"
        [formControl]="comment"
        class="dp-input-control comment-text"
        (keydown)="restrictInput($event)"
      >
      </textarea>
    </div>
  </form>
  <div class="btn-div d-flex flex-column">
    <button class="btn-content" (click)="onMergeClick()">
      <img src="../../../assets/images/tick.svg" /><span>Yes, Merge Codes</span>
    </button>
    <button class="dp-tertiary-btn btn-cancel" mat-dialog-close>
      No, Cancel
    </button>
  </div>
</div>
